<script setup lang="ts">
/** A font's status, in words and in the colour that goes with it. */
import { useI18n } from 'vue-i18n'

import StatusChip from '@/components/ui/StatusChip.vue'
import type { FontStatus } from '@/domain/facsimile/fonts'

defineProps<{ status: FontStatus }>()

const { t } = useI18n()

const TONES = { complete: 'good', partial: 'warn', missing: 'danger' } as const
</script>

<template>
  <StatusChip :tone="TONES[status]">{{ t(`fonts.status.${status}`) }}</StatusChip>
</template>
